import React, { useState } from 'react';

function App() {
  const [status, setStatus] = useState('idle');
  const [email, setEmail] = useState('');
  const [spamTrap, setSpamTrap] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (spamTrap) return;
    setStatus('loading');

    try {
      const res = await fetch('https://api.airtable.com/v0/appHZuFg9JUTbCwxT/Waitlist', {
        method: 'POST',
        headers: {
          Authorization: 'Bearer pat7F2b5AY1IETOlO.9a5d0dc607f21015f9b6d46765928863b4ec60c59d6b767c82dfcae63c979379',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ fields: { Email: email } }),
      });

      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        throw new Error();
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans">

      {/* Header */}
      <header className="px-6 py-4 flex items-center space-x-4">
        <img src="/logo.png" alt="Savr logo" className="h-16 w-16" />
        <span className="text-2xl font-bold text-gray-800 tracking-tight"></span>
      </header>

      {/* Hero */}
      <section className="px-6 py-20 text-center bg-gradient-to-b from-white to-gray-50">
        <h1 className="text-4xl md:text-5xl font-bold">Smarter Spending, Powered by AI</h1>
        <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
          Meet <strong>Savr</strong> — your personal savings engine. Optimize every dollar you spend. Detect waste. Negotiate better deals.
        </p>
        <a href="#waitlist">
          <button className="mt-6 bg-red-600 text-white px-6 py-3 rounded-xl hover:bg-red-700 transition">
            Join the Waitlist
          </button>
        </a>
      </section>

      {/* Features */}
      <section className="px-6 py-16 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 text-left">
        <div>
          <h2 className="text-xl font-semibold">Smart Spend Analysis</h2>
          <p className="mt-2 text-gray-600">Savr scans your purchases, detects overspending, and surfaces better buying strategies.</p>
        </div>
        <div>
          <h2 className="text-xl font-semibold">AI-Powered Recommendations</h2>
          <p className="mt-2 text-gray-600">Get actionable insights to switch suppliers, bundle smarter, or cancel wasteful subscriptions.</p>
        </div>
        <div>
          <h2 className="text-xl font-semibold">DealDesk Negotiation Assistant</h2>
          <p className="mt-2 text-gray-600">Upload bills or quotes and DealDesk drafts emails to lower your internet, rent, or vendor pricing.</p>
        </div>
      </section>

      {/* How It Works */}
      <section className="px-6 py-20 bg-gray-100 text-center">
        <h2 className="text-3xl font-bold">How It Works</h2>
        <div className="mt-12 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="text-4xl">📥</div>
            <h3 className="text-xl font-semibold mt-4">Upload Receipts or Bills</h3>
            <p className="text-gray-600 mt-2">Easily connect your inbox or upload files to get started.</p>
          </div>
          <div>
            <div className="text-4xl">🤖</div>
            <h3 className="text-xl font-semibold mt-4">AI Finds Opportunities</h3>
            <p className="text-gray-600 mt-2">Our engine identifies what to cut, switch, or renegotiate.</p>
          </div>
          <div>
            <div className="text-4xl">💸</div>
            <h3 className="text-xl font-semibold mt-4">Save Without Lifting a Finger</h3>
            <p className="text-gray-600 mt-2">Take action instantly or let DealDesk draft it for you.</p>
          </div>
        </div>
      </section>

      {/* Waitlist Form */}
      <section id="waitlist" className="px-6 py-20 text-center bg-white">
        <h2 className="text-2xl font-bold">Be the first to save smarter with Savr.</h2>
        <p className="mt-2 text-gray-600">Join our waitlist and get early access before we launch.</p>

        {status === 'success' ? (
          <p className="mt-6 text-green-600 font-medium">✅ Thanks for signing up! You're on the list.</p>
        ) : (
          <form onSubmit={handleSubmit} className="mt-6 max-w-md mx-auto">
            <input
              type="email"
              name="email"
              required
              placeholder="you@example.com"
              className="w-full px-4 py-3 border border-gray-300 rounded-xl"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="text"
              name="confirm_email"
              className="hidden"
              value={spamTrap}
              onChange={(e) => setSpamTrap(e.target.value)}
            />
            <button
              type="submit"
              className="mt-4 w-full bg-red-600 text-white px-6 py-3 rounded-xl hover:bg-red-700 transition"
              disabled={status === 'loading'}
            >
              {status === 'loading' ? 'Sending…' : 'Request Invite'}
            </button>
            {status === 'error' && (
              <p className="mt-2 text-sm text-red-600">Something went wrong. Please try again.</p>
            )}
          </form>
        )}
      </section>

      {/* Footer */}
      <footer className="px-6 py-10 text-center text-gray-400 text-sm">
        &copy; {new Date().getFullYear()} Savr. Built with 💡 by a procurement pro.
      </footer>
    </div>
  );
}

export default App;
